import { Auth0Client } from '@auth0/auth0-spa-js';
import { getConfig } from '@client/config/runtime';
import { generateHref } from '@shared/utils/core/navigation';

let auth0Client: Auth0Client | null = null;

export function getAuth0Client(): Auth0Client {
    if (!auth0Client) {
        auth0Client = new Auth0Client({
            domain: getConfig('AUTH0_DOMAIN', import.meta.env.VITE_AUTH0_DOMAIN),
            clientId: getConfig('AUTH0_CLIENT_ID', import.meta.env.VITE_AUTH0_CLIENT_ID),
            useRefreshTokens: true,
            cacheLocation: 'localstorage',
            authorizationParams: {
                audience: getConfig('AUTH0_AUDIENCE', import.meta.env.VITE_AUTH0_AUDIENCE),
                redirect_uri: generateHref({
                    baseUrl: window.location.origin,
                    to: '/callback',
                }),
            },
        });
    }
    return auth0Client;
}

export async function loginWithRedirect(options?: {
    appState?: Record<string, any>;
    authorizationParams?: Record<string, any>;
    forceReauth?: boolean;
}) {
    const client = getAuth0Client();

    if (options?.forceReauth) {
        return client.loginWithRedirect({
            ...options,
            authorizationParams: {
                ...options.authorizationParams,
                prompt: 'login',
            },
        });
    } else {
        return client.loginWithRedirect(options);
    }
}

export async function handleRedirectCallback(url?: string) {
    const client = getAuth0Client();
    return client.handleRedirectCallback(url);
}
